import React from 'react'
import { colors } from '../../Colors'

export interface IProps {
    width?: number
    height?: number
    color?: string
}

const ExchangeIcon = ({ width = 24, height = 24, color = colors.grey[50] }: IProps) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 24 24' fill='none'>
            <path
                d='M8.46154 19.1508C7.11615 18.6338 6.13385 17.7531 5.59154 16.6154H3.84615V14.3077L0 18.1538L3.84615 22V19.6923H8.46154V19.1508ZM23.0769 5.84615L19.2308 2V4.30769H14.6154V4.93923C15.8177 5.47385 16.7254 6.32538 17.2454 7.38462H19.2308V9.69231L23.0769 5.84615ZM16.43 14.2454C16.43 12.3923 15.3946 11.3485 13.0885 10.9031L11.5831 10.6115C10.3531 10.3685 9.83539 9.99692 9.83539 9.35769C9.83539 8.58077 10.5231 8.08692 11.5669 8.08692C12.6108 8.08692 13.3954 8.66154 13.4608 9.48692H16.2038C16.1646 7.76769 14.9492 6.49 13.0769 6.03769V4.30769H10V6.03077C8.07308 6.47923 6.88154 7.79154 6.88154 9.62462C6.88154 11.4615 7.98231 12.6269 10.1185 13.0315L11.6562 13.3392C12.9915 13.6062 13.5008 13.9538 13.5008 14.6015C13.5008 15.37 12.74 15.9046 11.6315 15.9046C10.4015 15.9046 9.55231 15.3623 9.47923 14.5131H6.64692C6.68615 16.3454 7.94308 17.5915 10 17.9954V19.6923H13.0769V17.9831C15.1831 17.5523 16.43 16.2262 16.43 14.2454Z'
                fill={color}
            />
        </svg>
    )
}

export default React.memo(ExchangeIcon)
